import { Component } from './Component';
import { SvgPath } from './svg/SvgPath';
var IS_TOUCH_DEVICE = 'ontouchstart' in window;
var ELEMENT = /** @class */ (function () {
    function ELEMENT(tagName, props, childNodes) {
        this.el = this.createElement(tagName || 'DIV');
        if (typeof props === 'string') {
            this.el.className = props;
        }
        else {
            if (props.id)
                this.el.setAttribute('id', props.id);
            if (props.className)
                this.el.className = props.className;
            if (props.attrs)
                this.setAttrs(props.attrs);
            if (props.style)
                Object.assign(this.el.style, props.style);
            if (props.onClick)
                this.el.addEventListener(IS_TOUCH_DEVICE ? 'touchstart' : 'click', props.onClick);
            if (props.onClickOnly)
                this.el.addEventListener('click', props.onClickOnly);
            if (props.onScroll)
                this.el.addEventListener('scroll', props.onScroll);
        }
        // child node
        if (Array.isArray(childNodes)) {
            for (var i = 0; i < childNodes.length; i++) {
                var child = childNodes[i];
                if (typeof child === 'string') {
                    var textNode = document.createTextNode(child);
                    this.el.appendChild(textNode);
                }
                else if (child instanceof Component || child instanceof ELEMENT || child instanceof SvgPath) {
                    this.el.appendChild(child.valueOf());
                }
                else if (child instanceof HTMLElement) {
                    this.el.appendChild(child);
                }
            }
        }
        else if (typeof childNodes === 'string') {
            var textNode = document.createTextNode(childNodes);
            this.el.appendChild(textNode);
        }
    }
    ELEMENT.prototype.valueOf = function () {
        return this.el;
    };
    ELEMENT.prototype.toggleClassName = function (name, force) {
        this.el.classList.toggle(name, force);
    };
    Object.defineProperty(ELEMENT.prototype, "className", {
        set: function (name) {
            this.el.className = name;
        },
        enumerable: false,
        configurable: true
    });
    ELEMENT.prototype.hasClassName = function (name) {
        return this.el.classList.contains(name);
    };
    ELEMENT.prototype.text = function (text) {
        this.el.innerText = text;
    };
    ELEMENT.prototype.html = function (html) {
        this.el.innerHTML = html;
    };
    ELEMENT.prototype.attr = function (name, value) {
        this.el.setAttribute(name, value);
    };
    ELEMENT.prototype.rmAttr = function (name) {
        this.el.removeAttribute(name);
    };
    ELEMENT.prototype.appendChild = function (child, force) {
        var _this = this;
        if (force)
            this.removeAllChild();
        if (Array.isArray(child)) {
            child.forEach(function (i) { return _this.el.appendChild(i.valueOf()); });
        }
        else {
            this.el.appendChild(child.valueOf());
        }
    };
    ELEMENT.prototype.removeFirstChild = function () {
        if (this.el.childNodes[0]) {
            this.el.removeChild(this.el.childNodes[0]);
        }
    };
    ELEMENT.prototype.removeChild = function (child) {
        this.el.removeChild(child.el);
    };
    Object.defineProperty(ELEMENT.prototype, "countChild", {
        get: function () {
            return this.el.childNodes.length;
        },
        enumerable: false,
        configurable: true
    });
    ELEMENT.prototype.removeAllChild = function () {
        while (this.el.firstChild)
            this.el.removeChild(this.el.lastChild);
    };
    ELEMENT.prototype.createElement = function (tagName) {
        return document.createElement(tagName);
    };
    ELEMENT.prototype.setAttrs = function (attrs) {
        for (var key in attrs) {
            if (attrs.hasOwnProperty(key))
                this.el.setAttribute(key, attrs[key]);
        }
    };
    Object.defineProperty(ELEMENT.prototype, "style", {
        // Стили
        get: function () {
            return this.el.style;
        },
        enumerable: false,
        configurable: true
    });
    ELEMENT.prototype.css = function (style, value) {
        if (typeof style === 'string') {
            // @ts-ignore
            this.el.style[style] = value;
        }
        else {
            for (var key in style) {
                if (style.hasOwnProperty(key)) {
                    // @ts-ignore
                    this.el.style[key] = value[key];
                }
            }
        }
    };
    return ELEMENT;
}());
export { ELEMENT };
